<mat-form-field [class]="formFieldClass()" [hideRequiredMarker]="hideRequiredMarker()">
  <mat-label>{{ label }}</mat-label>
  @if (prefixIcon()) {
    <mat-icon
      [class]="prefixIconClass()"
      matPrefix
      [matTooltip]="prefixIconTooltip()"
      [svgIcon]="prefixIcon()"
    ></mat-icon>
  }
  <input
    #inputField
    matInput
    [formControl]="dateInputCtrl"
    [required]="required()"
    (change)="dateInputChangeHandler($event)"
  />
  <ng-content select="[matPrefix]"></ng-content>
  <mat-hint>{{ hint() }}</mat-hint>
  @if (dateInputCtrl.hasError('dateFormatInvalid')) {
    <mat-error>{{ dateFormatInvalidLabel() }}</mat-error>
  }
  @if (dateInputCtrl.hasError('required')) {
    <mat-error [innerHTML]="requiredErrorLabel()"></mat-error>
  }
  @if (dateInputCtrl.hasError('externalError')) {
    <mat-error [innerHTML]="error()"></mat-error>
  }
  <mat-datepicker-toggle [disabled]="disabled()" matSuffix [for]="dp"></mat-datepicker-toggle>
  <mat-datepicker
    #dp
    startView="multi-year"
    (yearSelected)="chosenYearHandler($event)"
    (monthSelected)="chosenMonthHandler($event)"
    panelClass="datepicker__panel"
  >
    <input matInput [matDatepicker]="dp" [formControl]="dateCtrl" (dateChange)="dateChangeHandler($event)" />
  </mat-datepicker>
</mat-form-field>
